module.exports = __webpack_public_path__ + "static/media/walkie-talkie.a5615dca.svg";